import React from "react";
import {
  Utensils, Coffee, Hotel, Salad, Briefcase, GraduationCap, HeartPulse, ShoppingBag, Bike
} from "lucide-react";

const industries = [
  { icon: <Utensils size={18} />, label: "Restaurants" },
  { icon: <Coffee size={18} />, label: "Cafes" },
  { icon: <Hotel size={18} />, label: "Hotels" },
  { icon: <Salad size={18} />, label: "Catering Services" },
  { icon: <Briefcase size={18} />, label: "Corporate Offices" },
  { icon: <GraduationCap size={18} />, label: "Educational Institutions" },
  { icon: <HeartPulse size={18} />, label: "Hospitals" },
  { icon: <ShoppingBag size={18} />, label: "Retail Chains" },
  { icon: <Bike size={18} />, label: "Food Delivery" },
];

export const Industries = () => {
  return (
    <section id="industries" data-testid="industries-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-3xl">
          <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
            Industries We Serve
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold text-neutral-900 leading-[1.05]">
            Trusted across India&apos;s <span className="vc-text-gradient">hospitality, food & retail</span>.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {industries.map((i, idx) => (
            <div
              key={i.label}
              data-testid={`industry-${idx}`}
              className="group rounded-2xl border border-neutral-200 p-6 bg-white hover:border-neutral-300 hover:-translate-y-0.5 hover:shadow-lg transition-all flex items-center gap-4"
            >
              <div className="w-12 h-12 rounded-xl vc-gradient text-white flex items-center justify-center group-hover:scale-105 transition-transform">
                {i.icon}
              </div>
              <div className="font-display text-lg font-bold text-neutral-900">{i.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
